import { Component, Injector, OnInit } from '@angular/core';
import { practitionerI } from 'app/core/interfaces/practitioner';
import { PractitionerService } from 'app/core/http/services/practitioner.service';
import { ProcedureService } from 'app/core/http/services/procedure.service';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { PatientScheduleRegistrationComponent } from '../registration/schedule-registration.component';

@Component({
  selector: 'page-schedule',
  templateUrl: './schedule-appointment.component.html',
  styleUrls: ['./schedule-appointment.component.scss'],
})
export class ScheduleAppointmentPatientComponent extends BaseComponent implements OnInit {
  public title = 'Agendar consulta';
  public search = '';
  public practitioners: any[] = [];

  public procedure: any = {};

  public patientLogged: any = {};

  public get practitionersFilter(): practitionerI[] {
    const practitioners = [...this.practitioners];
    return practitioners.filter(
      (item: practitionerI) =>
        this.search == '' ||
        (item.name && item.name.indexOf(this.search) > -1) ||
        (item.specialty && item.specialty.indexOf(this.search) > -1) ||
        (item.address && item.address.city && item.address.city.indexOf(this.search) > -1)
    );
  }

  constructor(private practitionerService: PractitionerService, private healthcareService: ProcedureService, private injector: Injector) {
    super(injector);
  }

  async ngOnInit() {
    const userLogged = this.getUserLogged();

    await this.getPractitioners();
    this.getProcedures();
  }

  openEncounterRegistrationForm(practitioner: any) {
    const data = {
      title: 'Agendar consulta',
      param: {
        practitioner,
        type: 'Consulta',
        procedure: this.procedure,
        patient: this.patientLogged,
      },
    };

    this.dialog.openComponentDialog(PatientScheduleRegistrationComponent, data);
  }

  async getPractitioners() {
    return this.practitionerService.list().subscribe({
      next: (resPractioner: any) => {
        this.practitioners = resPractioner;
      },
      error: (err: any) => {
        console.log('Falha ao buscar medicos', err);
      },
    });
  }

  getProcedures() {
    this.healthcareService.getProcedures().subscribe({
      next: (resHealthcare) => {
        this.procedure = this.transformToFormData(resHealthcare[0]);
      },
      error: (err) => {
        console.log('Falha ao buscar Healthcares', err);
      },
    });
  }

  getSpecialization(practitioner: any) {
    let speciality = 'Undefined';
    if (practitioner?.qualification[0]?.identifier[0]?.value) {
      speciality = practitioner?.qualification[0]?.identifier[0]?.value;
    }
    return speciality;
  }

  getPrefix(practitioner: practitionerI) {
    if (practitioner.gender) {
      return practitioner.gender == 'Female' ? 'Dra. ' : 'Dr. ';
    }
    return '';
  }

  getCity(practitioner: any) {
    let address = 'Undefined';
    if (practitioner.address && (practitioner?.address[0]?.city || practitioner?.address[0]?.state)) {
      address = `${practitioner?.address[0]?.city}/${practitioner?.address[0].state}`;
    }
    return address;
  }

  transformToFormData(healthcareserviceData: any): any {
    return {
      healthcareservice_id: healthcareserviceData.healthcareservice_id,
      name: healthcareserviceData.name,
      description: healthcareserviceData.description,
      organization: {
        name: healthcareserviceData.providedBy.display,
        organization_id: healthcareserviceData.providedBy.code,
      },
      extraDetails: healthcareserviceData.extraDetails,
      type: healthcareserviceData?.type[0]?.coding[0]?.display,
      price_low: parseInt(healthcareserviceData?.valueRange?.low?.value),
      price_high: parseInt(healthcareserviceData?.valueRange?.high?.value),
      status: healthcareserviceData.status,
      specialty: healthcareserviceData.specialty[0].coding[0].display,
      comment: healthcareserviceData.comments,
      averageDuration: healthcareserviceData?.averageDuration ?? 30,
      appointmentRequired: healthcareserviceData.appointmentRequired,
    };
  }
}
